import PropTypes from 'prop-types';

import CustomSVGIcon from './CustomSVGIcon';

const Amplion = ({ color = '', ...other }) => {
	return (
		<CustomSVGIcon {...other} width={24} height={24}>
			<path
				d="M21.7589759,3.54851595 C21.9158539,3.76462336 22,4.02203197 22,4.28582468 L22,17.3469961 C22,18.0570765 21.4030463,18.6327104 20.6666667,18.6327104 C20.3931039,18.6327104 20.1261616,18.5515695 19.9020502,18.4002943 L14.3809524,14.6735532 L8.64548525,14.6735532 L7.33333333,21 L3.33333333,21 L4.64548525,14.6735532 L3.33333333,14.6735532 C2.59695367,14.6735532 2,14.0979194 2,13.387839 L2,9.5306961 C2,8.82061571 2.59695367,8.24498182 3.33333333,8.24498182 L12.4761905,8.24498182 L19.9020502,3.2325265 C20.5053159,2.82532213 21.3366899,2.96679543 21.7589759,3.54851595 Z M20.9497217,4.13595844 C20.8605107,4.01306566 20.6821627,3.96732907 20.5330784,4.02423466 L20.4615231,4.06135897 L12.7821058,9.24497088 L3.33333333,9.24497088 C3.16870317,9.24497088 3.04139819,9.34505072 3.00838513,9.46778746 L3,9.53068546 L3,13.3878322 C3,13.5159706 3.10378639,13.634356 3.25439242,13.6655653 L3.33333333,13.6735468 L5.87417511,13.6735468 L4.561,20 L6.519,20 L7.83161022,13.6735468 L14.6868677,13.6735468 L20.4615231,17.5714431 C20.5198578,17.6108191 20.591869,17.632708 20.6666667,17.632708 C20.8312968,17.632708 20.9586018,17.5326281 20.9916149,17.4098914 L21,17.3469934 L21,4.28580871 C21,4.25110816 20.992457,4.21646664 20.9775597,4.18363341 L20.9497217,4.13595844 Z"
				id="Amplion"
				fill={color}
			/>
		</CustomSVGIcon>
	);
};

Amplion.propTypes = {
	color: PropTypes.string,
};

export default Amplion;
